import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-cta text-cta-foreground shadow-lg shadow-cta/25 ring-1 ring-inset ring-black/10 hover:bg-cta-hover',
    secondary: 'border border-primary/40 bg-surface text-foreground hover:bg-surface-hover',
    outline: 'border-2 border-primary bg-transparent text-foreground hover:bg-surface'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-7 py-5 text-base sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-extrabold uppercase tracking-wide transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-199" data-mp="onu02ba00nbm">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-200" data-mp="12n3cczv32xab" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-201" data-mp="xos4uvs9gyv9">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-202" data-mp="1cdy0k9rw46ye" />}
    </button>;
}